export default __webpack_public_path__ + "static/media/9.faa3b327.gif";